<template>
    <div>
        <Breadcumb title="Forum d'échanges" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <div class="cardcontainer">
                <b-card no-body class="mb-3">
                    <b-card-header class="row no-gutters align-items-center">
                        <div class="col font-weight-bold">Catégorie du forum</div>
                        <!--<div class="d-none d-md-block col-6 text-muted">
                            <div class="row no-gutters align-items-center">
                                <div class="col-3">Threads</div>
                                <div class="col-3">Replies</div>
                                <div class="col-6">Last update</div>
                            </div>
                        </div>-->
                    </b-card-header>
                    <div v-for="(forum, index) in categories" :key="forum.name">
                        <b-card-body class="py-3">
                    
                            <div class="row no-gutters align-items-center">
                                <div class="col">
                                    <b-btn v-bind:to="'/echanges/forum/' + forum.id + '/'"  class="text-big font-weight-semibold" variant="primary">
                                        {{forum.name}}
                                    </b-btn>
                                </div>
                                <!--<div class="d-none d-md-block col-6">
                            
                                    <div class="row no-gutters align-items-center">
                                        <div class="col-3">Nb article</div>
                                        <div class="col-3">nb reponse</div>
                                        <div class="col-6">
                                            <div v-if="1==1 || forum.lastUpdate" class="media align-items-center">
                                                <div class="media-body flex-truncate ml-2">
                                                    <a href="javascript:void(0)" class="d-block text-truncate">titre dernier article</a>
                                                    <div class="text-muted small text-truncate">date dernier article ago &nbsp;·&nbsp; <a href="javascript:void(0)" class="text-muted">nom de l'autheur</a></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                        
                                </div>-->
                            </div>
                
                        </b-card-body>
                        <hr class="m-0">
                    </div>
                </b-card>
        </div>
    </div>
</template>

<script>
    import Breadcumb from '../components/breadcumb'
    import {GET_CATEGORIES_REQUEST} from "../_store/exchange/actiontypes";
    import { mapState } from 'vuex';
    export default {
        components: { Breadcumb},
        name: 'forumList',
        computed: mapState({ categories: state => state.exchange.categories}),
        mounted() {
            this.$store.dispatch(GET_CATEGORIES_REQUEST)
        },
        data() {
            return {
                breadcumbData: [
                    {text: this.$t('welcome'), href: '/dashboard/'},
                    {text: "Forum d'échange", active: true},
                ],
                forumPath: [
                    {text: 'Forums', active: true}
                ],
            }
        }
    }
</script>
